var _excluded = ["title", "disabled", "id", "tooltip", "component", "to", "icon"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import React from 'react';
import ReactToolTip from 'react-tooltip';
import { TabsContainer, TabItem, TabIcon, TabTitle } from "./styles";
import { InfoFillIcon } from "../Icons";
import { COLORS } from "../../constants/colors";
export var Tabs = function Tabs(_ref) {
  var divider = _ref.divider,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'standard' : _ref$variant,
    _ref$scrollButtons = _ref.scrollButtons,
    scrollButtons = _ref$scrollButtons === void 0 ? 'auto' : _ref$scrollButtons,
    items = _ref.items,
    currentTab = _ref.currentTab,
    onChangeTab = _ref.onChangeTab;
  return /*#__PURE__*/React.createElement(TabsContainer, {
    divider: divider,
    variant: variant,
    scrollButtons: scrollButtons,
    value: currentTab,
    onChange: function onChange(_, index) {
      if (onChangeTab) {
        onChangeTab(index);
      }
    }
  }, items.filter(function (item) {
    return !!item.title || !!item.icon;
  }).map(function (_ref2) {
    var title = _ref2.title,
      disabled = _ref2.disabled,
      id = _ref2.id,
      tooltip = _ref2.tooltip,
      component = _ref2.component,
      to = _ref2.to,
      icon = _ref2.icon,
      itemProps = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/React.createElement(TabItem, {
      "aria-controls": itemProps['aria-controls'],
      disabled: disabled,
      icon: (tooltip || icon) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabIcon, {
        "data-tip": tooltip,
        "data-for": "tooltip-".concat(id)
      }, icon || /*#__PURE__*/React.createElement(InfoFillIcon, {
        fill: COLORS.primary.active,
        role: "img"
      })), /*#__PURE__*/React.createElement(ReactToolTip, {
        id: "tooltip-".concat(id)
      })),
      id: id,
      key: id,
      label: /*#__PURE__*/React.createElement(TabTitle, {
        variant: "tab",
        component: "span"
      }, title),
      component: component,
      to: to
    });
  }));
};